export default __webpack_public_path__ + "static/media/1.0183e4da.png";